<template>
  <div class="preview_box">
    <div class="title_box">请设置自测试卷</div>
    <!-- 答题模式 -->
    <div class="mode-cards">
      <!-- 单题模式 -->
      <div
        class="mode-card mode-cardLeft01"
        :class="{ selected: previewMode === 'paginated' }"
        @click="previewMode = 'paginated'"
      >
        <!-- <div class="icon-container">
          <svg class="mode-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1"></path>
            <path d="M12 17v.01"></path>
            <path d="M12 14a2 2 0 0 0 1.882-1.348A1.99 1.99 0 0 0 14 12V9a2 2 0 0 0-4 0v3c0 .226.037.444.106.654A2 2 0 0 0 12 14z"></path>
            <rect x="8" y="3" width="8" height="4" rx="1" ry="1"></rect>
          </svg>
        </div> -->
        <h2 class="mode-title">单题模式</h2>
        <!-- <p class="mode-description">一次只显示一道题目，逐题作答</p> -->
        <div class="radio-indicator">
          <div class="radio-dot"></div>
        </div>
      </div>

      <!-- 多题模式 -->
      <div
        class="mode-card mode-cardLeft02"
        :class="{ selected: previewMode === 'scrolled' }"
        @click="previewMode = 'scrolled'"
      >
        <!-- <div class="icon-container">
          <svg class="mode-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
            <path d="M15 2H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"></path>
            <path d="m9 14 2 2 4-4"></path>
          </svg>
        </div> -->
        <h2 class="mode-title">多题模式</h2>
        <!-- <p class="mode-description">一次显示多道题目，可自由切换作答</p> -->
        <div class="radio-indicator">
          <div class="radio-dot"></div>
        </div>
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="50px">
      <div class="flex_rowx">
        <div class="flex_row">
          <el-form-item label="时长:">
            <div class="border_row">
              <el-select
              style="width: 40%"
                v-model="form.durationType"
                placeholder="限时/不限时"
                @change="changeValue"
              >
                <el-option label="限时" value="1"></el-option>
                <el-option label="不限时" value="2"></el-option>
              </el-select>
              <div
                style="display: flex; flex-direction: row; align-items: center"
              >
                <el-input
                  v-model="form.testDuration"
                  placeholder="请输入"
                  :disabled="disabledTest"
                  style="width: 75px"
                  maxlength="3"
                  minlength="1"
                  @input="(v) => (form.testDuration = v.replace(/[^\d]/g, ''))"
                ></el-input>
                <div style="margin-right: 15px; color: #333333">分钟</div>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="flex_row">
          <el-form-item label="题数:">
            <div class="border_row">
              <el-select
              style="width: 40%"
                v-model="form.numType"
                placeholder="随机/自定义"
                @change="changeValue"
              >
                <el-option label="随机" value="3"></el-option>
                <el-option label="自定义" value="4"></el-option>
              </el-select>
              <div
                style="display: flex; flex-direction: row; align-items: center"
              >
                <el-input
                  type="number"
                  v-model="form.questionNum"
                  :placeholder="questiontotal"
                  :disabled="disabledNum"
                  style="width: 75px"
                  :min="1"
                  @input="handlerchangelimit"
                ></el-input>
                <!-- @input="(v) => (form.questionNum = v.replace(/[^\d]/g, ''))" -->

                <div style="margin-right: 15px; color: #333333">道</div>
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="select_box" v-if="selectShow">
      <div class="titel_ti">自定义题型</div>
      <div v-for="(item, index) in typeList" :key="index">
        <div class="select_index_flex">
          <div class="select_index">
            <el-select
              v-model="item.moduleName"
              placeholder="请选择"
              @change="(val) => checkChange(val, index)"
            >
              <el-option
                v-for="item in paperTypeList"
                :key="item.questionType"
                :label="paperType[Number(item.questionType) - 1].name"
                :value="item.questionType"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select_flex">
            <div style="margin-left: 20px; width: 50px; font-size: 14px">
              抽取
            </div>
            <el-input
              type="number"
              v-model="item.moduleQuestionNum"
              :placeholder="item.maxnumber"
              style="width: 200px"
              :max="item.maxnumber"
              :min="1"
              @input="handlerchangelimitItem"
            ></el-input>
            <div class="size" style="margin-right: 20px; font-size: 14px">
              道
            </div>
          </div>
          <img
            v-if="typeList.length > 1"
            src="@/assets/images/shanchu.png"
            style="width: 14px; height: 16px"
            @click="deletes(index)"
          />
        </div>
        <div
          class="moduleQuestionType13"
          v-if="item.moduleQuestionType == '13'"
        >
          注意：简答题不自动判错
        </div>
      </div>

      <div class="but_box" @click="add">+ 添加题型</div>
    </div>
    <div class="answer" @click="startTest">开始答卷</div>
  </div>
</template>
<script>
import { paperGetToken, getPaperIdApi, updatePaperId } from "@/api/index/index";
import {
  addPaperApi,
  selQuestionTypeAndNumBySubject,
} from "@/api/answer/answer";
export default {
  name: 'previewBox',
  props: {
    subjectId: {
      type: String,
      default: "",
    },
    questionCount: {
      type: String,
      default: "",
    },
    filesId: {
      type: String,
      default: "",
    },
    goodsId: {
      type: String,
      default: "",
    },
    bookName: {
      type: String,
      default: "",
    },
    previewMode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      checkindex: 0,
      questiontotal: 0,
      itemquestiontotal: 0,
      disabledNum: false,
      disabledTest: false,
      form: {
        durationType: "1",
        numType: "3",
        subjectId: "",
        testDuration: 60,
        questionNum: 0,
      },
      paperType: [],
      selectShow: false,
      typeList: [],
      paperTypeList: [],
      default: [
        {
          moduleName: "单选题",
          moduleQuestionNum: 0,
          moduleQuestionType: 1,
          orderNum: 1,
          maxnumber: 0,
        },
      ],
      // previewMode: "",
    };
  },
  created() {
    this.paperType = this.$store.getters.paperType;
    // this.subjectId = this.$route.query.subjectId;
    // this.questionCount = this.$route.query.questionCount;
    // this.goodsId = this.$route.query.goodsId;
    // this.filesId = this.$route.query.filesId;
    // this.previewMode = this.$route.query.previewMode
    this.getQuestionNumber();
  },
  methods: {
    // 根据学科查询题型及题型数量
    getQuestionNumber() {
      paperGetToken().then((token) => {
        selQuestionTypeAndNumBySubject(
          {
            subjectId: this.subjectId,
          },
          token.data
        ).then((res) => {
          this.paperTypeList = res.data || [];
          this.form.questionNum = this.paperTypeList.reduce((per, item) => {
            return (per += Number(item.questionNum));
          }, 0);

          this.default[0].maxnumber = this.paperTypeList[0].questionNum;

          let indexs = this.paperTypeList.findIndex((item) => {
            return item.questionType == "1";
          });
          this.default[0].moduleQuestionNum =
            this.paperTypeList[indexs].questionNum;
          this.questiontotal = this.form.questionNum;
        });
      });
    },

    deletes(index) {
      if (this.typeList.length > 1) {
        this.typeList.splice(index, 1);
      }
    },
    handlerchangelimit(value) {
      if (value) {
        value = String(value).replace(/[^\d]/g, "");
      }
      if (value <= 0) {
        value = 1;
      }
      if (value > this.questiontotal) {
        this.form.questionNum = this.questiontotal;
      }
    },

    handlerchangelimitItem(value) {
      console.log(
        this.typeList[this.checkindex],
        "this.typeList[this.checkindex]"
      );
      console.log("value", value);
      if (value) {
        value = String(value).replace(/[^\d]/g, "");
      }
      if (value <= 0) {
        value = 1;
      }
      if (value > Number(this.typeList[this.checkindex].maxnumber)) {
        this.typeList[this.checkindex].moduleQuestionNum =
          this.typeList[this.checkindex].maxnumber;
      }
    },

    checkChange(val, index) {
      this.checkindex = index;
      var data = this.paperType.find((value) => value.questionType == val);
      let nums = 0;
      this.paperTypeList.forEach((item) => {
        if (data.questionType == item.questionType) {
          nums = item.questionNum;
        }
      });
      this.itemquestiontotal = nums;
      var selectIndex = this.typeList.findIndex(
        (value) => value.moduleQuestionType == val
      );
      if (selectIndex == -1) {
        this.typeList[index].moduleName = data.name;
        this.typeList[index].moduleQuestionType = data.questionType;
        this.typeList[index].moduleQuestionNum = nums;
        // 最大值
        this.typeList[index].maxnumber = nums;
      } else {
        this.$message.success("已存在");
        if (this.typeList.length > 1) {
          this.typeList.splice(index, 1);
        }
      }
    },
    changeValue(e) {
      
      //4自定义 3随机
      if (e == 4) {
        this.typeList = this.default;
        this.disabledNum = true;
        this.form.questionNum = "";
        this.selectShow = true;
      } else if (e == 3) {
        this.selectShow = false;
        this.typeList = [];
        this.disabledNum = false;
        this.form.questionNum = this.questiontotal;
      } else if (e == 2) {
        this.form.testDuration = "";
        this.disabledTest = true;
      } else if (e == 1) {
        this.form.testDuration = 60;
        this.disabledTest = false;
      }
    },
    add() {
      let form = {
        moduleName: "",
        moduleQuestionNum: 1,
        moduleQuestionType: "",
        orderNum: 1,
      };
      this.typeList.push(form);
    },
    //开始答题
    startTest() {
      getPaperIdApi().then((paperId) => {
        let data = {
          subjectId: this.subjectId,
          testDuration: this.form.testDuration,
          questionNum: this.form.questionNum,
          paperGenerateMethod: "zcms",
          testPaperModuleList: this.typeList,
          stemSort: 0,
          createUserId: this.$store.getters.userId,
          id: paperId.data,
          fullMark: 0,
          passMark: 0,
        };
        paperGetToken().then((token) => {
          data.token = token.data;
          addPaperApi(data).then((res) => {
            this.$store.commit("SET_testPaperId", res.id);
            updatePaperId({ paperId: res.id, goodsId: this.goodsId });
            this.$router.push({
              path: "/bookstore/paperAnswer",
              query: {
                paperId: res.id,
                answerType: "examination",
                goodsId: this.goodsId,
                typeOk: true,
                // bookName: this.$route.query.bookName,
                bookName: this.bookName,
                previewMode: this.previewMode,
                paperGenerateMethod: "zcms",
              },
            });
            // window.open(routeUrl.href, "_blank");
          });
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.preview_box {
  width: 100%;
  background: #fffefd;
  margin: 0 auto;
  padding-bottom: 0px;
  .title_box {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    text-align: center;
    padding: 0px 0 15px 0;
    border-bottom: 2px solid #f2f2f2;
  }
}
.select_box {
  // width: 1200px;
  width: 97%;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.18);
  border-radius: 10px;
  margin: 0 auto;
  padding-bottom: 10px;
  .titel_ti {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    text-align: center;
    padding: 25px 0 15px 0;
    border-bottom: 2px solid #f2f2f2;
    margin-bottom: 20px;
  }
}
.flex_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  ::v-deep .el-input__inner {
    border: none;
    background: #fffefd;
  }
}

.border_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  // width: 503px;
  border: 1px solid #cccccc;
  border-radius: 6px;
  width: 215px;
}
.flex_rowx {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 20px auto 0px auto;
}
.select_index {
  border: 1px solid #cccccc;
  border-radius: 6px;
  width: 123px;
  background: #fff;
  ::v-deep .el-input__inner {
    border: none;
    background: #fff;
  }
}
.select_flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 219px;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 6px;
  background: #fff;
  ::v-deep .el-input__inner {
    border: none;
    background: #fff;
  }
}
.select_index_flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 400px;
  margin: 20px auto;
}
.but_box {
  cursor: pointer;
  width: 32%;
  height: 48px;
  background: #ffa83a;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.18);
  border-radius: 6px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 48px;
  text-align: center;
  margin: 20px auto;
}
.answer {
  width: 30%;
  cursor: pointer;
  // width: 902px;
  height: 48px;
  background: #2e9adb;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.18);
  border-radius: 6px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 48px;
  text-align: center;
  margin: 20px auto 0 auto;
}
.moduleQuestionType13 {
  width: 400px;
  margin: 0 auto;
  color: #ffaa30;
  font-size: 16px;
  font-family: PingFang SC;
}

/* 定义CSS变量 */
.preview_box {
  --primary-color: #42b983;
  --secondary-color: #3490dc;
  --text-color: #2c3e50;
  --light-gray: #f8f9fa;
  --medium-gray: #e9ecef;
  --dark-gray: #6c757d;
  --border-radius: 12px;
  --box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  --transition-time: 0.3s;
}

/* 基础样式 */
.quiz-container {
  font-family: "Helvetica Neue", Arial, sans-serif;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  color: var(--text-color);
}

.quiz-title {
  text-align: center;
  font-size: 28px;
  margin-bottom: 40px;
  font-weight: 600;
}

/* 卡片容器 */
.mode-cards {
  display: flex;
  justify-content: center;
  // gap: 30px;
  margin-bottom: 30px;
  padding-top: 20px;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .mode-cards {
    flex-direction: column;
    align-items: center;
  }
}

/* 模式卡片 */
.mode-card {
  position: relative;
  width: 216px;
  padding: 8px;
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  cursor: pointer;
  transition: transform var(--transition-time),
    box-shadow var(--transition-time);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border: 2px solid transparent;

}
.mode-cardLeft01 { 
  margin-left: 44px;
}
.mode-cardLeft02 { 
  margin-left: 77px;
}

.mode-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.mode-card.selected {
  border-color: var(--primary-color);
  background-color: rgba(66, 185, 131, 0.05);
}

.mode-card:nth-child(2).selected {
  border-color: var(--secondary-color);
  background-color: rgba(52, 144, 220, 0.05);
}

/* 图标样式 */
.icon-container {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mode-icon {
  width: 40px;
  height: 40px;
  stroke: var(--primary-color);
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: stroke var(--transition-time);
}

.mode-card:nth-child(2) .mode-icon {
  stroke: var(--secondary-color);
}

/* 文字样式 */
.mode-title {
  font-size: 16px;
  font-weight: 600;
  // margin-bottom: 10px;
  text-align: center;
}

.mode-description {
  color: var(--dark-gray);
  text-align: center;
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 20px;
}

/* 单选指示器 */
.radio-indicator {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--medium-gray);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color var(--transition-time);
}

.radio-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: transparent;
  transition: background-color var(--transition-time);
}

.mode-card.selected .radio-indicator {
  border-color: var(--primary-color);
}

.mode-card.selected .radio-dot {
  background-color: var(--primary-color);
}

.mode-card:nth-child(2).selected .radio-indicator {
  border-color: var(--secondary-color);
}

.mode-card:nth-child(2).selected .radio-dot {
  background-color: var(--secondary-color);
}

/* 按钮样式 */
.start-button {
  display: block;
  margin: 0 auto;
  padding: 12px 40px;
  font-size: 18px;
  font-weight: 500;
  color: white;
  background-color: var(--text-color);
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color var(--transition-time),
    transform var(--transition-time);
}

.start-button:hover:not(.disabled) {
  background-color: #1a2533;
  transform: translateY(-2px);
}

.start-button:active:not(.disabled) {
  transform: translateY(0);
}

.start-button.disabled {
  background-color: var(--medium-gray);
  color: var(--dark-gray);
  cursor: not-allowed;
}
</style>
